<script>
    import { FormBox, Typography, Button } from '$lib/components/UI'
    import { strftime, getDateObj, currencyFormatter } from '$lib/utils'
    import dictionaries from '$lib/stores/dictionaries'
    import { jsPDF } from 'jspdf'
    import logo from '../../../assets/logo.svg'
    import { createEventDispatcher } from 'svelte'
    import 'svg2pdf.js'
    import { elementToSVG, inlineResources } from 'dom-to-svg'
    import { DatatableX as Datatable  } from '$lib/components/UI'
    import createDataStore from '$lib/stores/datastore'
    export let data = {}
    export const downloadAction = () => {
        dispatch('download');
        savePDF();
    }
    let element

    const dispatch = createEventDispatcher()
    async function savePDF(){
        // html2pdf().ssavePDFet(opt).from(element).toCanvas().toPdf().save()
        let scale = 0.24
        // @ts-ignore
        let doc = new jsPDF({
            orientation: "portrait",
            unit: "mm",
            format: [297, 210],
            compressPdf: true
        })
        let svg = elementToSVG(element)
        await inlineResources(svg.documentElement)
        console.log({
            height: element.clientHeight,
            width: element.clientWidth
        })
        doc.svg(svg.documentElement, {
          x: 0,
          y: 0,
        //   height: scale*1145.1973,
          height: scale * element.clientHeight,
          width:  scale * element.clientWidth
        //   width: scale* 816.37732
        }).then(() => {
            doc.save(`REM-${data.id_oferta}.pdf`)
        }).catch(e => 
            console.log(e)
        )
    }
    $: title = `Remito de Entrega [${data.id_oferta.replace('OFERTA-', '#')}]`
</script>
<div class="viewport">
    <div class="container" bind:this={element}>
        <div style="display: flex; align-items: center; gap: 15px">
            <img width="47" height="56" src="{logo}" alt=""/>
            <Typography style="font-size: 18px">{title}</Typography>
        </div>
        <p class="address">LA CAJA S.A.</p>
        <p class="address">FITZ ROY 957</p>
        <p class="address">CIUDAD AUTONOA DE BUENOS AIRES</p>
        <p class="address">C1414CHI BUENOS AIRES</p>
        <p class="address">ARGENTINA</p>
        <!-- <Typography>Datos del Asegurado</Typography> -->
        <Typography style="font-size: 14px">Datos del Asegurado</Typography>
        <FormBox.Container style="--padding:5px 17px; --min-height: 0px; --label-font-size: 9px; --gap: 0px; --value-font-size: 11px">
            <FormBox.Row>
                <FormBox.Cell  label="Asegurado" value={data.asegurado.nombre_apellido_asegurado}/>
            </FormBox.Row>
            <FormBox.Row>
                <FormBox.Cell label="Domicilio" value={`${data.asegurado.calle} ${data.asegurado.altura}`}/>
                <FormBox.Cell label="Provincia" value={data.asegurado.jurisdiccion}/>
                <FormBox.Cell label="Localidad" value={data.asegurado.localidad}/>
            </FormBox.Row>
            <FormBox.Row>
                <FormBox.Cell label="Celular" value={data.asegurado.celular_asegurado}/>
                <FormBox.Cell label="Email" value={data.asegurado.email_asegurado}/>
            </FormBox.Row>
            <FormBox.Row>
                <FormBox.Cell label="Vehículo" value={`${data.vehiculo.marca} ${data.vehiculo.modelo}`}/>
            </FormBox.Row>
            <FormBox.Row>
                <FormBox.Cell label="Año" value={data.vehiculo.anio_vehiculo}/>
                <FormBox.Cell label="Patente" value={data.vehiculo.patente}/>
                <FormBox.Cell label="Chasis" value={data.vehiculo.numero_chasis}/>
            </FormBox.Row>
            <FormBox.Row>
                <FormBox.Cell label="Fecha Siniestro" value={strftime('%d/%m/%Y %H:%M', getDateObj(data.siniestro.fecha))}/>
                <FormBox.Cell label="Nro Siniestro" value={data.id_siniestro}/>
            </FormBox.Row>
            <FormBox.Row>
                <FormBox.Cell label="Póliza" value={data.asegurado.numero_poliza}/>
            </FormBox.Row>
        </FormBox.Container>
        <Typography style="font-size: 14px">Producto entregado</Typography>
        <Datatable
            --background-freeze-cell="none"
            --row-height="30px"
            --header-height="30px"
            --body-font-size="11px"
            --header-font-size="9px"
            data={createDataStore(data.items)}
            schema={{
                // categoria: {label: 'Categoría'},
                producto: { render: p => $dictionaries.lic_items_polaris.find(x => x.value === p)?.label || p },
                descripcion: { label: 'Descripción' },
                cantidad: {}
                // precio_unitario: { render: n => currencyFormatter({n, lang: 'es-AR', type: 'ARS'}) },
                // total: { render: n => currencyFormatter({n, lang: 'es-AR', type: 'ARS'}) }
            }}
        >
            <!-- <svelte:fragment slot="endOfRows">
                <tr>
                    <td></td>
                    <td></td>
                    <td style="font-size: 11px">Total</td>
                    <td><strong style="font-size: 11px">{currencyFormatter({ n: data.items.reduce((a, b) => a+b.total, 0), lang: 'es-AR', type: 'ARS' })}</strong></td>
                </tr>
            </svelte:fragment> -->
        </Datatable>
        <br/>
        <p class="fillFormRow">Firma:</p>
        <p class="fillFormRow">Aclaración:</p>
        <p class="fillFormRow">DNI:</p>
    </div>
    <!-- <Button style="margin: 15px; position: stick; z-index: 9999; bottom: 0" on:click={() => {dispatch('download'); savePDF()}}>Descargar</Button> -->
</div>

<style>
    @page {
      size: 210mm 297mm;  /* DIN A4 */
      margin: 25mm;
    }
    /* .viewport {
        display: flex;
        flex-direction: column;
        height: auto;
        background: red;
        overflow-y: visible;
        position: absolute;
    } */
    .container {
        width: 230mm;
        padding: 15mm;
        /* height: 297mm; */
        /* font-family: 'Lucida Sans', 'Lucida Sans Regular', 'Lucida Grande', 'Lucida Sans Unicode', Geneva, Verdana, sans-serif;
        font-size: medium; */
    }
    .fillFormRow {
        font-size: 11px;
        width: 100%;
        position: relative;
        border-bottom: 1px #c0c0c0 dashed;
        margin: 10px 0 40px 0;
    }
    .address{
        font-size: 11px;
    }
</style>